import type { ButtonHTMLAttributes, ReactNode } from "react";
import { MailTooltip } from "@/features/shared/MailTooltip";
import { cn } from "@/lib/cn";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  side?: "top" | "bottom";
  tooltipClassName?: string;
  children: ReactNode;
};

/** Bouton icône avec infobulle — lecteur de message uniquement. */
export function MailIconTooltipButton({
  label,
  side = "top",
  tooltipClassName,
  className,
  children,
  type = "button",
  ...props
}: Props) {
  return (
    <MailTooltip label={label} side={side} className={tooltipClassName} compact>
      <button type={type} aria-label={label} className={cn(className)} {...props}>
        {children}
      </button>
    </MailTooltip>
  );
}
